import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const DefaultHomeRoute = () => {
  const { isAuthenticated, loading, defaultHomeRoute } = useAuth();

  if (loading) return null;
  if (!isAuthenticated) return <Navigate to="/client-overview" replace />;

  return <Navigate to={defaultHomeRoute || '/dashboard'} replace />;
};

export default DefaultHomeRoute;
